function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.3 127.6h-50.2l14.8-21.3-23.2-16.2-26.2 37.5h-28.6V99.2l37.6-26.3-16.3-23.2-21.3 14.9V14.2h-28.3v50.3l-21.3-14.8-16.2 23.2 37.5 26.2v28.5H99.2L72.9 90l-23.2 16.2 14.9 21.4H14.2v28.3h50.3l-14.8 21.2 23.2 16.3 26.2-37.5h28.5v28.6l-37.5 26.2 16.2 23.3 21.3-14.9v50.2h28.3V219l21.3 14.9 16.3-23.2-37.6-26.3v-28.5h28.5l26.3 37.6 23.2-16.3-14.9-21.3h50.3z"
})));